import { mapGetters } from 'vuex'

export const Head = {
  head() {
    if (this.metaObj) {
      return {
        title: this.metaObj.title,
        meta: [
          {
            hid: 'description',
            name: 'description',
            content: this.metaObj.description ? this.metaObj.description : ''
          },
          {
            hid: 'og:title',
            property: 'og:title',
            content: this.metaObj.og_title ? this.metaObj.og_title : ''
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content: this.metaObj.og_description
              ? this.metaObj.og_description
              : ''
          },
          {
            hid: 'twitter:title',
            property: 'twitter:title',
            content: this.metaObj.twitter_title
              ? this.metaObj.twitter_title
              : ''
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content: this.metaObj.twitter_description
              ? this.metaObj.twitter_description
              : ''
          },
          {
            hid: 'twitter:image',
            property: 'twitter:image',
            content: this.metaObj.twitter_image
              ? this.RESOURCES_URL + this.metaObj.twitter_image
              : ''
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.metaObj.og_image
              ? this.RESOURCES_URL + this.metaObj.og_image
              : ''
          },
          {
            hid: 'og:url',
            name: 'og:url',
            content: this.URL
          }
        ],
        link: [
          {
            rel: 'canonical',
            href: this.URL
          }
        ]
      }
    }
  },
  data() {
    return {
      origin: null
    }
  },
  computed: {
    ...mapGetters('data', ['URL', 'RESOURCES_URL'])
  },
  mounted() {
    this.origin = window.location.origin
  }
}



// WEBPACK FOOTER //
// ./mixins/Head.js